import getContentLibrary, {
  getLibFromPath
} from "../players/utils/ContentFactory";
import ContentPaths from "../players/utils/ContentPaths";
import BaseConfig from "../players/utils/BaseConfig";
import { config } from "bluebird";

export type ResourceMapEntry = {
  resourceLoaded: boolean;
  lib: any;
  libLoadingTime: number;
  resLoadingTime: number;
};
enum ConfigProperty {
  gameName = "gameName"
}
export namespace GlobalResourceManager {
  export let loadedResourceMap = {};
  // Added gameLoadedMapEntry to show splashScreen every time we start a game.
  // As we have a common item now we have to download
  // resource every time different game is slected from same item.
  export let gameLoadedMapEntry: Map<string, boolean> = new Map();
  export async function loadResource(
    config: BaseConfig,
    id: string,
    paths: ContentPaths
  ): Promise<any> {
    await GlobalResourceManager.loadLibOnly(paths.lib.slice(), id, config);
    let resourceLoaded = GlobalResourceManager.loadedResourceMap[id].resourceLoaded;
    let gameName = config.getProperty(ConfigProperty.gameName);
    let loadedMapEntry = GlobalResourceManager.gameLoadedMapEntry.get(gameName);
    if ((resourceLoaded === undefined && !resourceLoaded) || (gameName !== undefined && !loadedMapEntry)) {
      let loadingStartTime = Date.now();
      let contentLib = GlobalResourceManager.loadedResourceMap[id].lib;
      let content = new contentLib(config);
      if (gameName) {
        GlobalResourceManager.gameLoadedMapEntry.set(gameName, true);
      }
      GlobalResourceManager.loadedResourceMap[id].resourceLoaded = true;
      await content.loadResources(paths);
      GlobalResourceManager.loadedResourceMap[id].resLoadingTime =
        Date.now() - loadingStartTime;
      return content;
    }
  }
  export async function loadLibOnly(path, id, config?: any): Promise<void> {
    let loadingStartTime = Date.now();
    let gameName = config.getProperty(ConfigProperty.gameName);
    if (gameName !== undefined) {
      if (!GlobalResourceManager.gameLoadedMapEntry.has(gameName)) {
        GlobalResourceManager.gameLoadedMapEntry.set(gameName, false);
      }
    }
    GlobalResourceManager.loadedResourceMap[id] =
      GlobalResourceManager.loadedResourceMap[id] || {};
    if (!GlobalResourceManager.loadedResourceMap[id].lib) {
      await getContentLibrary(path);
      GlobalResourceManager.loadedResourceMap[id].lib = getLibFromPath(path);
    }
    GlobalResourceManager.loadedResourceMap[id].libLoadingTime =
      Date.now() - loadingStartTime;
  }

  export function getContentLib(id): any {
    GlobalResourceManager.loadedResourceMap[id] =
      GlobalResourceManager.loadedResourceMap[id] || {};
    return GlobalResourceManager.loadedResourceMap[id].lib;
  }

  export function getLoadingTime(id): number {
    return (
      (GlobalResourceManager.loadedResourceMap[id].libLoadingTime || 0) +
      (GlobalResourceManager.loadedResourceMap[id].resLoadingTime || 0)
    );
  }
}
